export const getCustomFieldUid = (entityId: string, fieldId: string) => `${entityId}-${fieldId}`
